import getUrl from "./rest";
import http from "./http";

const API = "categories";

const categoryService = {
  getAll: (filters = {}) => http.get(getUrl(`${API}`), filters),
};

export default categoryService;
